import styled from 'styled-components'
import { backgroundOrange, orange } from '@/theme/colors'

export const PageContainer = styled.div`
	background-color: ${backgroundOrange};
	height: 100%;
	display: flex;
	flex-direction: column;
	overflow: hidden;
`

export const ContentRow = styled.div`
	display: flex;
	flex: 1;
	min-height: 0;
	overflow: hidden;

	@media (max-width: 768px) {
		flex-direction: column;
	}
`

export const SidePanel = styled.aside`
	width: 380px;
	flex-shrink: 0;
	display: flex;
	flex-direction: column;
	background: white;
	border-right: 1px solid #e9ecef;
	overflow: hidden;

	@media (max-width: 768px) {
		width: 100%;
		height: 45%;
		border-right: none;
		border-top: 1px solid #e9ecef;
		order: 2;
	}
`

export const MapWrapper = styled.div`
	flex: 1;
	position: relative;
	min-width: 0;

	@media (max-width: 768px) {
		order: 1;
		height: 55%;
	}
`

export const PageHeader = styled.div`
	padding: 1rem 1.25rem 0.75rem;
	display: flex;
	align-items: center;
	gap: 0.75rem;
	flex-shrink: 0;
	border-bottom: 1px solid #f1f3f5;
`

export const BackButton = styled.button`
	background: transparent;
	color: ${orange};
	border: none;
	padding: 0.25rem 0;
	font-weight: 600;
	font-size: 0.9rem;
	cursor: pointer;

	&:hover {
		opacity: 0.8;
		text-decoration: underline;
	}
`

export const PageTitle = styled.h2`
	margin: 0;
	font-size: 1.1rem;
	font-weight: 700;
	color: #212529;
`

export const LoadingContainer = styled.div`
	display: flex;
	flex: 1;
	background-color: ${backgroundOrange};
	height: 100%;
`

export const ErrorContainer = styled.div`
	padding: 2rem;
	text-align: center;
	color: red;
`

export const EmptyStateContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 1;
	padding: 2rem;
`

export const EmptyState = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 1.25rem;
	text-align: center;
	max-width: 420px;
`

export const EmptyStateIcon = styled.div`
	color: #adb5bd;
	display: flex;
	align-items: center;
	justify-content: center;
`

export const EmptyStateTitle = styled.h3`
	margin: 0;
	font-size: 1.25rem;
	color: #212529;
`

export const EmptyStateText = styled.p`
	font-size: 1rem;
	color: #6c757d;
	margin: 0;
	line-height: 1.6;
`

export const EmptyStateButton = styled.button`
	background: ${orange};
	color: white;
	border: none;
	padding: 0.6rem 1.25rem;
	border-radius: 8px;
	font-size: 0.95rem;
	font-weight: 600;
	cursor: pointer;

	&:hover {
		opacity: 0.9;
	}
`
